var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.displayLoading ? _c('div', [_c('Loading')], 1) : _vm._e(), _c('div', {
    staticClass: "page"
  }, [_c('div', {
    staticClass: "d-flex invoice-tab mb-3"
  }, [_c('router-link', {
    staticClass: "invoice-tab--item",
    attrs: {
      "to": {
        name: 'EinvoiceQueryByCarrier'
      }
    }
  }, [_vm._v("手動輸入")]), _c('router-link', {
    staticClass: "invoice-tab--item",
    attrs: {
      "to": {
        name: 'EinvoiceScan'
      }
    }
  }, [_vm._v("上傳照片")])], 1), _c('p', [_vm._v("result : " + _vm._s(_vm.result))]), _c('p', [_vm._v("error : " + _vm._s(_vm.error))])]), _c('div', {
    staticClass: "page__button"
  }, [_c('SharedButton', {
    staticClass: "s-btn-bg-primary",
    on: {
      "click": function click($event) {
        return _vm.openQRCodeReader();
      }
    }
  }, [_vm._v(" 開啟 QR Code 掃瞄器 ")])], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }